import React, { useEffect, useState } from 'react';
import sellImages from "../../../../assets/images/sell_physical_recharge_plan_id_17_image.png";
import heroImg from "../../../../assets/images/tlsm-model.png";
import bannerImg from "../../../../assets/images/telsimnw.png";
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import { ThreeDots } from 'react-loader-spinner'
import swal from 'sweetalert';
import { toast } from 'react-toastify';
// import  heroImg from "../../../../assets/images/tlsm-model.png"   
import cartImg from "../../../../assets/images/shopping_cart.svg";



const SERVER_URL = process.env.REACT_APP_API_URL;

 const retailer_id= sessionStorage.getItem('retailerID')
const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};

function Plans ({ handleShowCart,setShowCart }) {

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addedToCart, setAddedToCart] = useState({}); // Object to track added to cart status for each plan

  // To store quantity for each plan dynamically
  const [quantities, setQuantities] = useState({});
  const [totalcount, setTotalCount] = useState("")

  const [cartData, setCartData] = useState({
    retailer_id: sessionStorage.getItem('retailerID'),
    tap_plan_id: "",
    quantity: ""
  });

  useEffect(() => {
    handleSearch();
    scrollToBottom();
  }, []);


  const scrollToBottom = () => {
    window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
    });
};

  // Fetch plans from the server
  const handleSearch = async () => {
    try {
      setLoading(true);
      const header = await getApiHeader();
      const retailer_id = sessionStorage.getItem('retailerID');
      const params = new URLSearchParams();
      params.append('retailer_id', retailer_id);

      const response = await axios.get(`${SERVER_URL}purchase-physical-recharge-vouchers?${params.toString()}`, {
        headers: header
      });

      if (response.status === 200) {
        setTotalCount(response.data.data.total_cart_count)
        const data = response.data.data.plans;
        setPlans(data);
    
        // Initialize quantities for each plan
        const initialQuantities = {};
        data.forEach(plan => {
          initialQuantities[plan.tap_plan_id] = plan.stock_quantity; // Start with  stock quantity 
        });
        setQuantities(initialQuantities);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in search request:", error);
    }
  };


  

  // Increment quantity for a specific plan
  const incrementQty = (tap_plan_id) => {
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[tap_plan_id] || 0;
      if (currentQty < 30) { // Limit quantity to 30
        return { ...prevQuantities, [tap_plan_id]: currentQty + 1 };
      }
      return prevQuantities;
    });
  };

  // Decrement quantity for a specific plan
  const decrementQty = (tap_plan_id) => {
    setQuantities(prevQuantities => {
      const currentQty = prevQuantities[tap_plan_id] || 0;
      if (currentQty > 0) { // Ensure quantity does not go below 0
        return { ...prevQuantities, [tap_plan_id]: currentQty - 1 };
      }
      return prevQuantities;
    });
  };

  // Get the quantity for a specific plan
  const getQuantity = (tap_plan_id) => quantities[tap_plan_id] || 0;

  // Handle the "Add to cart" button click
  const handleAddToCart = (planId,planName) => {
        
    console.log("planId===>",planId)
    getQuantity(planId) === 0 ?  swal(
      "",
     "Please specify the quantity of the product.",
      "warning"
    ) : null
    const quantity = getQuantity(planId); // Get the quantity for the specific plan
    console.log("Selected plan_id", planId, "Quantity:", quantity);

    if (quantity > 0) {
      // Update cartData with planId and quantity
      const updatedCartData = {
        retailer_id: sessionStorage.getItem('retailerID'),
        tap_plan_id: planId,
        quantity: quantity,
        plan_name: planName
      };
      setCartData(updatedCartData);

      // Send this `cartData` to the backend via API
      handleCart(updatedCartData, planId, planName);
    } else {
      console.log("Quantity is zero. Cannot add to cart.");
    }
  };

  // Send the cart data to the server
  const handleCart = async (cartData, planId, planName) => {
    try {
      setLoading(true)
      const header = await getApiHeader();
      const response = await axios.post(`${SERVER_URL}purchase-physical-recharge-vouchers/add-to-cart`, cartData, {
        headers: header
      });

      if (response.status === 200) {
        console.log("Item added to cart", response.data.data.cart_count_total);
        setTotalCount(response.data.data.cart_count_total)
        swal({
          //title: planName,
          text: `${planName} ${response.data.data.message}.`,
          icon: "success",
          button: "Close"
        });

        // Update `addedToCart` for the specific plan
        setAddedToCart(prevState => ({
          ...prevState,
          [planId]: true // Mark the specific plan as added to cart
        }));
        setLoading(false)
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
    }
  };

  const handleGoToCart = async () => {
    try {

      if (!totalcount) {
        // toast.error("please add items, your cart is empty")
        swal("","Please add items to your cart; it is currently empty.","warning")
        return
      }
       setLoading(true)
      const header = await getApiHeader();

      const formData = {
        retailer_id: sessionStorage.getItem('retailerID'),
      };

      const response = await axios.post(`${SERVER_URL}purchase-physical-recharge-vouchers/cart`, formData, { headers: header });
      let data=response.data.data
      if (response.status === 200) {
        // const res= await axios.post(`${SERVER_URL}purchase-physical-recharge-vouchers/checkout`, {},{
        //   headers: header
        // });
   
        //  if(res.status===200){
          //  paymentToken(res.data.data.payment_system_token)
            setShowCart(true,data)
            setLoading(false)
        //  }
      }

    } catch (error) {
      console.error("Error navigating to cart:", error);
      setLoading(false)
    }
  };

  return (
    <>
      {loading && (
        <div style={styles.wrapper}>
          <ThreeDots
            visible={loading}
            height="80"
            width="80"
            color="#e20e75"
            radius="9"
            ariaLabel="three-dots-loading"
          />
        </div>
      )}

      <div>
        <section id="hero-2" className="hero-2 d-flex align-items-center">
          <div className="container-fluid">
            <div className="hero-border">
              
                <div className="hero-background">
                  <img src={bannerImg} alt="" className="img-fluid banner-img"  style={{borderRadius:"10px"}}/>
                  </div>
                
            </div>
          </div>
        </section>

        <div className='container'>
          <div>


            <div className="CartStck" onClick={handleGoToCart}>
              <img src={cartImg} />
              <span id="CartCount">{totalcount}</span>
            </div>




          </div>
          {/* <div className='row' style={{ backgroundColor: '#fff', borderRadius: '30px', padding: '20px', paddingBottom: '50px', boxShadow: 'rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset' }}> */}
          <div className='row physical-voucher-wrapper' style={{ padding: '20px', paddingBottom: '50px',}}>
            {plans.map((plan, index) => (
              <div className='col-lg-5 col-md-6  physical-wrapper-row' key={index}>
                <div className='recharge-cards'>
                  <img src={plan.plan_image} alt="" className='img-fluid recharge-img' />
                  {/* <img src="http://retail-api.checkus.info/images/recharge_voucher_queueing/sell_physical_recharge_plan_id_17_image.png" alt="" className='img-fluid recharge-img' /> */}
          
                  <div className='plan-details'>
                    <p style={{ fontWeight: '500' }}>{plan.offerName}</p>
                    <span>
                      <p style={{ fontWeight: '900' }}>
                        <span style={{ color: 'red', textDecoration: 'line-through' }}>
                          ${plan.amount}
                        </span>
                        &nbsp;&nbsp;
                        ${plan.sell_amount}
                      </p>
                    </span>

                  </div>

                  <div className='flex vouchers-cart-sections'>
                    <div>
                      <button
                        className='cart-button'
                        onClick={() => handleAddToCart(plan.tap_plan_id, plan.offerName)}
                        // disabled={getQuantity(plan.tap_plan_id) === 0}
                      >
                        {/* {addedToCart[plan.plan_id] ? "Added to cart" : "Add to cart"} */}
                         Add to Cart <i class="fa fa-cart-plus" aria-hidden="true"></i>
                      </button>
                    </div>

                    <div className='control-box'>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => decrementQty(plan.tap_plan_id)}
                        disabled={getQuantity(plan.tap_plan_id) === 0 }
                      >
                        -
                      </button>
                      <span className="mx-2 value-box">
                        {getQuantity(plan.tap_plan_id)}
                      </span>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => incrementQty(plan.tap_plan_id)}
                        disabled={getQuantity(plan.tap_plan_id) >= 30 }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
             <div className='col-lg-11' >
          {totalcount > 0 ?
            <button className="go-to-cart" onClick={handleGoToCart}>
              View Cart <i class="fa fa-shopping-cart"></i>
            </button>
            : ""
          }
             </div>
          </div>


        </div>
      </div>
    </>
  );
}

export default Plans;
